module.exports = __webpack_public_path__ + "teqbahn-assets/media/Abdullah Keles, MD.d988c5fb.JPG";